// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer Styles */
.footer {
  background-color: var(--color-secondary);
  color: var(--color-text-primary);
}

/* Main Footer Content */

.footer-container {
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 3rem;
}

/* Contact Section */
.footer-contact {
  flex: 1 1;
  max-width: 400px;
  padding-top: 2rem;
  padding-bottom: 2rem;
  border-right: 1px solid #fff;
}

.contact-banner {
  margin-bottom: 2rem;
  overflow: hidden;
  white-space: nowrap;
  padding: 0.5rem 0;
}

/* Contact scroll uses global .scrolling-text class */

.contact-text {
  font-family: var(--font-family-scrolling);
  color: var(--color-white);
  font-weight: 700;
  font-size: 3rem;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.contact-text .solid {
  letter-spacing: 3px;
}

.contact-text .outline {
  letter-spacing: 3px;
  font-weight: 400;
}

.contact-info {
  color: var(--color-text-primary);
  padding-right: 3rem;
}

.contact-address {
  margin-bottom: 1.5rem;
}

.contact-address p {
  font-family: var(--font-family-footer);
  margin: 0.5rem 0;
  font-size: 1rem;
  line-height: 1.4;
  color: var(--color-white);
}

.contact-address a {
  color: var(--color-white);
  text-decoration: none;
  transition: color 0.3s ease;
}

.contact-address a:hover {
  color: var(--color-primary);
}

/* Social Links */
.social-links {
  display: flex;
  gap: 1.5rem;
  margin-top: 1.5rem;
  justify-content: flex-end;
}

.social-link {
  color: var(--color-text-primary);
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 1.5rem;
}

.social-link:hover {
  color: var(--color-primary);
  transform: scale(1.2);
}

/* Partner Logos Section */
.footer-partners {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.partner-logos {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  align-items: center;
  justify-content: center;
}

.partner-link {
  display: block;
  transition: all 0.3s ease;
  filter: brightness(0.8);
}

.partner-link:hover {
  transform: scale(1.05);
  filter: brightness(1);
}

.partner-logo {
  width: 100%;
  height: auto;
  max-width: 150px;
  max-height: 100px;
  object-fit: contain;
  padding: 0.5rem;
  border-radius: 4px;
}

/* Footer Bottom */
.footer-bottom {
  padding: 1.5rem 0;
  border-top: 1px solid #fff;
}

.footer-bottom-content {
  font-family: var(--font-family-footer);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  width: 100%;
}

.footer-bottom-content .powered-by {
  flex: 1 1;
  text-align: left;
}

.footer-bottom-content .copyright {
  flex: 1 1;
  text-align: center;
}

.footer-bottom-content .legal-links {
  flex: 1 1;
  text-align: right;
}

.powered-by a,
.legal-link {
  color: var(--color-text-primary);
  text-decoration: none;
  transition: color 0.3s ease;
}

.powered-by a:hover,
.legal-link:hover {
  color: var(--color-primary);
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    gap: 2rem;
    padding: 0 1rem;
  }

  .footer-contact {
    max-width: 100%;
    border-right: none;
    padding-right: 0;
  }
  .contact-address {
    text-align: center;
  }
  .contact-info {
    padding-right: 0;
  }

  .footer-partners {
    justify-content: center;
  }

  .partner-logos {
    justify-content: center;
    gap: 1.5rem;
  }

  .footer-bottom-content {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .social-links {
    flex-wrap: wrap;
    justify-content: center;
  }


  
  .contact-text {
    font-size: 3rem;
    letter-spacing: 1.5px;
  }
}

@media (max-width: 480px) {
  .footer-main {
    padding: 2rem 0 1.5rem 0;
  }

  .partner-logos {
    gap: 1rem;
  }

  .social-links {
    gap: 0.5rem;
  }

  .social-link {
    font-size: 1.2rem;
  }


  
  .contact-text {
    font-size: 2rem;
    letter-spacing: 1px;
  }
}

/* Speed control now in global App.css */ `, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,wBAAwB;;AAExB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,qDAAqD;;AAErD;EACE,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;;EAEE,gCAAgC;EAChC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;;;EAIA;IACE,eAAe;IACf,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;;;EAIA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,wCAAwC","sourcesContent":["/* Footer Styles */\n.footer {\n  background-color: var(--color-secondary);\n  color: var(--color-text-primary);\n}\n\n/* Main Footer Content */\n\n.footer-container {\n  max-width: 1500px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 3rem;\n}\n\n/* Contact Section */\n.footer-contact {\n  flex: 1;\n  max-width: 400px;\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n  border-right: 1px solid #fff;\n}\n\n.contact-banner {\n  margin-bottom: 2rem;\n  overflow: hidden;\n  white-space: nowrap;\n  padding: 0.5rem 0;\n}\n\n/* Contact scroll uses global .scrolling-text class */\n\n.contact-text {\n  font-family: var(--font-family-scrolling);\n  color: var(--color-white);\n  font-weight: 700;\n  font-size: 3rem;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n}\n\n.contact-text .solid {\n  letter-spacing: 3px;\n}\n\n.contact-text .outline {\n  letter-spacing: 3px;\n  font-weight: 400;\n}\n\n.contact-info {\n  color: var(--color-text-primary);\n  padding-right: 3rem;\n}\n\n.contact-address {\n  margin-bottom: 1.5rem;\n}\n\n.contact-address p {\n  font-family: var(--font-family-footer);\n  margin: 0.5rem 0;\n  font-size: 1rem;\n  line-height: 1.4;\n  color: var(--color-white);\n}\n\n.contact-address a {\n  color: var(--color-white);\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.contact-address a:hover {\n  color: var(--color-primary);\n}\n\n/* Social Links */\n.social-links {\n  display: flex;\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n  justify-content: flex-end;\n}\n\n.social-link {\n  color: var(--color-text-primary);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  font-size: 1.5rem;\n}\n\n.social-link:hover {\n  color: var(--color-primary);\n  transform: scale(1.2);\n}\n\n/* Partner Logos Section */\n.footer-partners {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n.partner-logos {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n  align-items: center;\n  justify-content: center;\n}\n\n.partner-link {\n  display: block;\n  transition: all 0.3s ease;\n  filter: brightness(0.8);\n}\n\n.partner-link:hover {\n  transform: scale(1.05);\n  filter: brightness(1);\n}\n\n.partner-logo {\n  width: 100%;\n  height: auto;\n  max-width: 150px;\n  max-height: 100px;\n  object-fit: contain;\n  padding: 0.5rem;\n  border-radius: 4px;\n}\n\n/* Footer Bottom */\n.footer-bottom {\n  padding: 1.5rem 0;\n  border-top: 1px solid #fff;\n}\n\n.footer-bottom-content {\n  font-family: var(--font-family-footer);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.9rem;\n  width: 100%;\n}\n\n.footer-bottom-content .powered-by {\n  flex: 1;\n  text-align: left;\n}\n\n.footer-bottom-content .copyright {\n  flex: 1;\n  text-align: center;\n}\n\n.footer-bottom-content .legal-links {\n  flex: 1;\n  text-align: right;\n}\n\n.powered-by a,\n.legal-link {\n  color: var(--color-text-primary);\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.powered-by a:hover,\n.legal-link:hover {\n  color: var(--color-primary);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .footer-container {\n    flex-direction: column;\n    gap: 2rem;\n    padding: 0 1rem;\n  }\n\n  .footer-contact {\n    max-width: 100%;\n    border-right: none;\n    padding-right: 0;\n  }\n  .contact-address {\n    text-align: center;\n  }\n  .contact-info {\n    padding-right: 0;\n  }\n\n  .footer-partners {\n    justify-content: center;\n  }\n\n  .partner-logos {\n    justify-content: center;\n    gap: 1.5rem;\n  }\n\n  .footer-bottom-content {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n\n  .social-links {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n\n  \n  .contact-text {\n    font-size: 3rem;\n    letter-spacing: 1.5px;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer-main {\n    padding: 2rem 0 1.5rem 0;\n  }\n\n  .partner-logos {\n    gap: 1rem;\n  }\n\n  .social-links {\n    gap: 0.5rem;\n  }\n\n  .social-link {\n    font-size: 1.2rem;\n  }\n\n\n  \n  .contact-text {\n    font-size: 2rem;\n    letter-spacing: 1px;\n  }\n}\n\n/* Speed control now in global App.css */ "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
